import React from "react";

export default function MainPiecesBox2({
  id,
  src,
  top,
  right,
  isSelect = false,
  setPiecesIndex,
}) {
  const pieceClickHandler = (e) => {
    if(e.target.id!="")setPiecesIndex(parseInt(e.target.id))
    
  };
  return (
    <>
      <div
        id={id}
        style={{
          top: `${top}vh`,
          right: `${right}vh`,
        }}
        className={`absolute w-[6.1vh] h-[6.1vh] max-w-[65px] max-h-[63px] ${
          isSelect
            ? "rounded-[15px] bg-[#fec62b8e] scale-125"
            : "rounded-[40px] bg-[#e5e5e5a4]"
        }  flex items-center justify-center  cursor-pointer  `}
        onClick={pieceClickHandler}
      >
        <div className="w-[6.1vh] h-[6.1vh] max-w-[65px] max-h-[63px] flex items-center justify-center p-[8px]">
          <img id={id} src={src} className="" />
        </div>
      </div>
    </>
  );
}
